import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

type Props = {
  isOpen: boolean
  onClose: () => void
}

/** SSOユーザーのアカウント有効化が完了したことを伝え、SSOログインへ誘導するダイアログ */
export const SSOAccountActivatedDialog: React.FC<Props> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>
          <Text fontSize="lg" fontWeight="bold">
            アカウントが有効化されました
          </Text>
        </ModalHeader>

        <ModalBody>
          <Text fontSize="md">
            <Text as="span" fontWeight="bold">
              「Microsoftでサインイン」
            </Text>
            ボタンからログインしてください。
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button onClick={onClose}>確認して閉じる</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
